

import { createSlice } from '@reduxjs/toolkit'

const initState = {
    state: false,
    roles: [],
    token: '',
    credentials: { user: '', pass: '' }
}


export const loggedSlice = createSlice({
    name: 'loggedStore',
    initialState: {
        value: initState,
    },
    reducers: {
        setLogged: (state, action) => {
            state.value = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { setLogged } = loggedSlice.actions

export default loggedSlice.reducer